<template>
	<div id="app">
	  <div class="container">
		<h1>OIDC Vue 登录示例</h1>
		
		<!-- 未登录状态 -->
		<div v-if="!user" class="login-section">
		  <p>请点击下面的按钮进行登录</p>
		  <button @click="handleLogin" class="login-btn">登录</button>
		</div>
		
		<!-- 已登录状态 -->
		<div v-else class="user-section">
		  <h2>欢迎回来！</h2>
		  <div class="user-info">
			<div v-if="userProfile.avatar" class="avatar">
			  <img :src="userProfile.avatar" alt="用户头像" />
			</div>
			<div class="info-list">
			  <div class="info-item">
				<span class="label">用户昵称：</span>
				<span class="value">{{ userProfile.nickname || '未提供' }}</span>
			  </div>
			  <div class="info-item">
				<span class="label">公司编号：</span>
				<span class="value">{{ userProfile.oucode || '未提供' }}</span>
			  </div>
			  <div class="info-item">
				<span class="label">公司名称：</span>
				<span class="value">{{ userProfile.ouname || '未提供' }}</span>
			  </div>
			  <div class="info-item">
				<span class="label">组织类型：</span>
				<span class="value">{{ userProfile.outype || '未提供' }}</span>
			  </div>
			</div>
		  </div>
		  
		  <!-- API 测试区域 -->
		  <div class="api-section">
			<h3>API 测试</h3>
			<div class="api-buttons">
			  <button @click="callApi" class="api-btn" :disabled="apiLoading">
				{{ apiLoading ? '调用中...' : '调用受保护的 API' }}
			  </button>
			</div>
			
			<!-- API 响应结果 -->
			<div v-if="apiResponse" class="api-response">
			  <h4>API 响应：</h4>
			  <pre>{{ apiResponse }}</pre>
			</div>
			
			<!-- API 错误信息 -->
			<div v-if="apiError" class="api-error">
			  <h4>错误：</h4>
			  <p>{{ apiError }}</p>
			</div>
		  </div>
		  
		  <button @click="handleLogout" class="logout-btn">登出</button>
		</div>
	  </div>
	</div>
  </template>
  
  <script>
  import oidcService from '@/utils/oidcConfig';
//   import apiService from './api-service';
  
  export default {
	name: 'App',
	data() {
	  return {
		user: null,
		userProfile: {
		  nickname: '',
		  avatar: '',
		  oucode: '',
		  ouname: '',
		  outype: ''
		},
		apiLoading: false,
		apiResponse: null,
		apiError: null
	  };
	},
	async mounted() {
	  // 检查是否是登录回调
	  if (window.location.pathname === '/signin-oidc') {
		try {
		  const user = await oidcService.handleCallback();
		  this.user = user;
		  this.extractUserInfo(user);
		  // 跳转回首页
		  window.history.replaceState({}, document.title, '/');
		} catch (error) {
		  console.error('处理登录回调失败:', error);
		}
		return;
	  }
	  
	  // 检查是否是登出回调
	  if (window.location.pathname === '/signout-callback-oidc') {
		try {
		  await oidcService.handleSignoutCallback();
		  // 清除本地状态
		  this.user = null;
		  this.clearUserProfile();
		  // 跳转回首页
		  window.history.replaceState({}, document.title, '/');
		} catch (error) {
		  console.error('处理登出回调失败:', error);
		  // 即使出错也清除本地状态
		  this.user = null;
		  this.clearUserProfile();
		  window.history.replaceState({}, document.title, '/');
		}
		return;
	  }
	  
	  // 检查用户是否已登录
	  const user = await oidcService.getUser();
	  if (user && !user.expired) {
		this.user = user;
		this.extractUserInfo(user);
	  }
	},
	methods: {
	  handleLogin() {
		oidcService.login();
	  },
	  handleLogout() {
		// 执行登出，会重定向到认证服务器
		// 登出后会跳转到 signout-callback-oidc，在那里清除本地状态
		oidcService.logout();
	  },
	  extractUserInfo(user) {
		if (user && user.profile) {
		  const profile = user.profile;
		  console.log(profile);
		  this.userProfile = {
			nickname: profile.nickname || profile.name || '',
			avatar: profile.avatar || profile.picture || '',
			oucode: profile.oucode || '',
			ouname: profile.ouname || '',
			outype: profile.outype || ''
		  };
		}
	  },
	  clearUserProfile() {
		this.userProfile = {
		  nickname: '',
		  avatar: '',
		  oucode: '',
		  ouname: '',
		  outype: ''
		};
	  },
	  async callApi() {
		if (!this.user || !this.user.access_token) {
		  this.apiError = '没有有效的访问令牌';
		  return;
		}
  
		this.apiLoading = true;
		this.apiResponse = null;
		this.apiError = null;
  
		try {
		  // 调用受保护的 API
		  const data = await apiService.getData(this.user.access_token);
		  this.apiResponse = JSON.stringify(data, null, 2);
		} catch (error) {
		  this.apiError = error.message || 'API 调用失败';
		  console.error('API 调用失败:', error);
		} finally {
		  this.apiLoading = false;
		}
	  }
	}
  };
  </script>
  
  <style>
  * {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
  }
  
  body {
	font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
  }
  
  #app {
	width: 100%;
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
  }
  
  .container {
	background: white;
	border-radius: 15px;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
	padding: 40px;
	max-width: 600px;
	width: 100%;
  }
  
  h1 {
	color: #333;
	margin-bottom: 30px;
	text-align: center;
	font-size: 28px;
  }
  
  h2 {
	color: #667eea;
	margin-bottom: 25px;
	text-align: center;
	font-size: 24px;
  }
  
  .login-section {
	text-align: center;
  }
  
  .login-section p {
	color: #666;
	margin-bottom: 25px;
	font-size: 16px;
  }
  
  .login-btn, .logout-btn {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
	border: none;
	padding: 15px 40px;
	font-size: 16px;
	border-radius: 50px;
	cursor: pointer;
	transition: transform 0.2s, box-shadow 0.2s;
	font-weight: 600;
  }
  
  .login-btn:hover, .logout-btn:hover {
	transform: translateY(-2px);
	box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
  }
  
  .login-btn:active, .logout-btn:active {
	transform: translateY(0);
  }
  
  .user-section {
	text-align: center;
  }
  
  .user-info {
	margin-bottom: 30px;
  }
  
  .avatar {
	margin-bottom: 25px;
  }
  
  .avatar img {
	width: 120px;
	height: 120px;
	border-radius: 50%;
	object-fit: cover;
	border: 4px solid #667eea;
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  
  .info-list {
	background: #f8f9fa;
	border-radius: 10px;
	padding: 25px;
	text-align: left;
  }
  
  .info-item {
	padding: 12px 0;
	border-bottom: 1px solid #e0e0e0;
	display: flex;
	align-items: center;
  }
  
  .info-item:last-child {
	border-bottom: none;
  }
  
  .info-item .label {
	font-weight: 600;
	color: #666;
	min-width: 100px;
	font-size: 14px;
  }
  
  .info-item .value {
	color: #333;
	flex: 1;
	font-size: 14px;
  }
  
  .logout-btn {
	background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  }
  
  .logout-btn:hover {
	box-shadow: 0 5px 20px rgba(245, 87, 108, 0.4);
  }
  
  .api-section {
	margin: 30px 0;
	padding: 25px;
	background: #f8f9fa;
	border-radius: 10px;
  }
  
  .api-section h3 {
	color: #667eea;
	font-size: 20px;
	margin-bottom: 20px;
	text-align: center;
  }
  
  .api-buttons {
	display: flex;
	justify-content: center;
	margin-bottom: 20px;
  }
  
  .api-btn {
	background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
	color: white;
	border: none;
	padding: 12px 30px;
	font-size: 14px;
	border-radius: 25px;
	cursor: pointer;
	transition: transform 0.2s, box-shadow 0.2s;
	font-weight: 600;
  }
  
  .api-btn:hover:not(:disabled) {
	transform: translateY(-2px);
	box-shadow: 0 5px 20px rgba(17, 153, 142, 0.4);
  }
  
  .api-btn:disabled {
	opacity: 0.6;
	cursor: not-allowed;
  }
  
  .api-response {
	background: white;
	border-radius: 8px;
	padding: 15px;
	margin-top: 15px;
  }
  
  .api-response h4 {
	color: #11998e;
	font-size: 16px;
	margin-bottom: 10px;
  }
  
  .api-response pre {
	background: #2d3748;
	color: #68d391;
	padding: 15px;
	border-radius: 5px;
	overflow-x: auto;
	font-size: 13px;
	line-height: 1.5;
	margin: 0;
  }
  
  .api-error {
	background: #fff5f5;
	border: 1px solid #fc8181;
	border-radius: 8px;
	padding: 15px;
	margin-top: 15px;
  }
  
  .api-error h4 {
	color: #c53030;
	font-size: 16px;
	margin-bottom: 10px;
  }
  
  .api-error p {
	color: #742a2a;
	margin: 0;
	font-size: 14px;
  }
  
  @media (max-width: 600px) {
	.container {
	  padding: 30px 20px;
	}
	
	h1 {
	  font-size: 24px;
	}
	
	h2 {
	  font-size: 20px;
	}
	
	.info-item {
	  flex-direction: column;
	  align-items: flex-start;
	}
	
	.info-item .label {
	  margin-bottom: 5px;
	}
  }
  </style>
  
  